export default "__VITE_ASSET__Bk4iiVqI__"